import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from "@nuxtjs/composition-api";
import { getClientRuntimeConfig } from "~/core/helpers/GlobalHelpers";
import { GETTERS as USER_FEEDBACK_GETTERS } from "~/store/affility/user/feedback/modals/full-loader/names";


export default /*#__PURE__*/_defineComponent({
  __name: 'FullScreenLoading',
  setup(__props) {

const context = useContext();

const isFullScreenLoadingVisible = computed(() =>
    context.store.getters[`affility/user/feedback/modals/full-loader/${USER_FEEDBACK_GETTERS.FULL_PAGE_LOADING_VISIBLE}`]
);
const fullScreenLoadingText = computed(() =>
    context.store.getters[`affility/user/feedback/modals/full-loader/${USER_FEEDBACK_GETTERS.FULL_PAGE_LOADING_TEXT}`]
);
const $config = getClientRuntimeConfig();
const isXmasMode = computed(() => $config.xmasMode);

return { __sfc: true,context, isFullScreenLoadingVisible, fullScreenLoadingText, $config, isXmasMode }
}

})